const qrcodeType = {
  STATIC: 'ESTATICO',
  IMMEDIATE_COLLECTION: 'COBRANCA_IMEDIATA',
  DUE_DATE_COLLECTION: 'COBRANCA_COM_VENCIMENTO'
};

module.exports = qrcodeType;
